import React, { useId } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

const unsupportedTypes = ['IS_FACE', 'FACE_ALIGNMENT_3000', 'PICOFACE'];

const UnsupportedModelIcon = ({ model }) => {
  const id = `unsupported-model-${useId().replace(/:/g, '')}`;
  if (!unsupportedTypes.includes((model.type || '').trim().toUpperCase())) return null;
  const message = `${model.type} is no longer supported.`;

  return (
    <>
      <span id={id} className="text-danger unsupported-model-icon" tabIndex={0} role="img" aria-label={message}>
        <i className="uil uil-exclamation-triangle" aria-hidden="true" />
      </span>
      <UncontrolledTooltip placement="top" popperClassName="unsupported-model-tooltip" target={id} trigger="hover focus">{message}</UncontrolledTooltip>
    </>
  );
};

export default UnsupportedModelIcon;
